import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  meta: "COMMERICALS",
};

export const getAllCommercials = createAsyncThunk(
  "commercials/getcommercials",
  async (payload) => {
    try {
      const response = await api.commericals.getAllCommercials(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateCommercials = createAsyncThunk(
  "commercials/getcommercials",
  async ({ id, payload }) => {
    try {
      const response = await api.commericals.updateCommercials(id, payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createCommercials = createAsyncThunk(
  "commercials/getcommercials",
  async ( payload ) => {
    try {
      const response = await api.commericals.createCommercials(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

// export const updateIndividualMemberBenefits = createAsyncThunk(
//   "memberBenefits/updateIndividualMemberBenefits",
//   async (payload) => {
//     try {
//       let id = payload?.ID;
//       delete payload?.ID;
//       const response = await api.memberBenefits.updateIndividualMemberBenefits(
//         id,
//         payload
//       );
//       if (response.status === 200) {
//         return response.data;
//       } else {
//         throw new Error(`Unexpected status code: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       throw error;
//     }
//   }
// );

const commercialsSlice = createSlice({
  name: "commercials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export const {} = commercialsSlice.actions;

export default commercialsSlice.reducer;
